import React, { useEffect, useState } from "react";
import InfoTag from "Components/common/InfoTag";
import { observer } from "mobx-react";

const CreditsInfo = observer((props = {}) => {
  const { memberData = "", liDailyUsage = [] } = props || {};
  const [personalInfo, setPersonalInfo] = useState("");

  const constructPersonalData = (memberData = "") => {
    if (memberData && Object.keys(memberData).length) {
      const {
        creditsEligible = 0,
        creditsUsed = 0,
        snImportUsed = 0,
        snImportEligible = 0,
        snContactsEligible = 0,
        snContactsUsed = 0,
        autologinKey = "",
        emailSendLimit = 0,
        emailSentCount = 0,
        emailValidationCredits = 0,
        usFreeCallingMinutesEligible = 0,
        usFreeCallingMinutesUsed = 0,
        dialerCredits = 0,
        liMonthlyMessageEligible = 0,
        liMonthlyMessageUsed = 0,
        liMonthlyInviteEligible = 0,
        liMonthlyInviteUsed = 0,
        noOfLiAccountsEligible = 0,
        noOfLiAccountsUsed = 0,
        noOfWaAccountsEligible = 0,
        noOfWaAccountsUsed = 0,
        waMaxMessagesPerDay = 0,
        noOfAgentsEligible = 0,
        noOfAgentsUsed = 0,
      } = memberData || {};
      const newObj = {
        creditsEligible,
        creditsUsed,
        snImportUsed,
        snImportEligible,
        snContactsEligible,
        snContactsUsed,
        autologinKey,
        emailSendLimit,
        emailSentCount,
        emailValidationCredits,
        usFreeCallingMinutesEligible,
        usFreeCallingMinutesUsed,
        dialerCredits,
        liMonthlyMessageEligible,
        liMonthlyMessageUsed,
        liMonthlyInviteEligible,
        liMonthlyInviteUsed,
        noOfLiAccountsEligible,
        noOfLiAccountsUsed,
        noOfWaAccountsEligible,
        noOfWaAccountsUsed,
        waMaxMessagesPerDay,
        noOfAgentsEligible,
        noOfAgentsUsed,
      };
      setPersonalInfo(newObj);
    }
  };

  const updateAllData = () => {
    memberData && constructPersonalData(memberData);
  };

  useEffect(() => {
    updateAllData();
  }, [memberData]);

  return (
    <div className="tableInfo">
      <div className="innerCont table">
        <div className="titleCont">
          <div className="title">Credits Information</div>
        </div>
        <div className="bodyCont">
          <InfoTag
            classValue="creditsEligible"
            label="Credits Eligible"
            value={personalInfo.creditsEligible}
          />
          <InfoTag
            classValue="creditsUsed"
            label="Credits Used"
            value={personalInfo.creditsUsed}
          />
          <InfoTag
            classValue="snImportEligible"
            label="Sales Navigator Import Eligible"
            value={personalInfo.snImportEligible}
          />
          <InfoTag
            classValue="snImportUsed"
            label="Sales Navigator Import Used"
            value={personalInfo.snImportUsed}
          />
          <InfoTag
            classValue="snContactsEligible"
            label="Sales Navigator Contact Import Limit"
            value={personalInfo.snContactsEligible}
          />
          <InfoTag
            classValue="snContactsUsed"
            label="Contacts Imported via Sales Navigator"
            value={personalInfo.snContactsUsed}
          />
          <InfoTag
            classValue="emailSendLimit"
            label="Email Send Limit"
            value={personalInfo.emailSendLimit}
          />

          <InfoTag
            classValue="emailSentCount"
            label="Emails Sent"
            value={personalInfo.emailSentCount}
          />

          <InfoTag
            classValue="emailValidationCredits"
            label="Email Validation Credits"
            value={personalInfo.emailValidationCredits}
          />

          <InfoTag
            classValue="usFreeCallingMinutesEligible"
            label="US Calling Minutes (Eligible)"
            value={personalInfo.usFreeCallingMinutesEligible}
          />

          <InfoTag
            classValue="usFreeCallingMinutesUsed"
            label="US Calling Minutes (Used)"
            value={personalInfo.usFreeCallingMinutesUsed}
          />

          <InfoTag
            classValue="dialerCredits"
            label="Dialer Credits"
            value={personalInfo.dialerCredits}
          />

          <InfoTag
            classValue="linkedInMessagesEligible"
            label="LinkedIn Messages (Eligible Monthly)"
            value={personalInfo.liMonthlyMessageEligible}
          />

          <InfoTag
            classValue="linkedInMessagesUsed"
            label="LinkedIn Messages (Used Monthly)"
            value={personalInfo.liMonthlyMessageUsed}
          />

          <InfoTag
            classValue="linkedInRequestsEligible"
            label="LinkedIn Requests (Eligible Monthly)"
            value={personalInfo.liMonthlyInviteEligible}
          />

          <InfoTag
            classValue="linkedInRequestsUsed"
            label="LinkedIn Requests (Used Monthly)"
            value={personalInfo.liMonthlyInviteUsed}
          />

          <InfoTag
            classValue="noOfLiAccountsEligible"
            label="LinkedIn Accounts (Eligible)"
            value={personalInfo.noOfLiAccountsEligible}
          />

          <InfoTag
            classValue="noOfLiAccountsUsed"
            label="LinkedIn Accounts (Used)"
            value={personalInfo.noOfLiAccountsUsed}
          />

          <InfoTag
            classValue="noOfWaAccountsEligible"
            label="WhatsApp Accounts (Eligible)"
            value={personalInfo.noOfWaAccountsEligible}
          />

          <InfoTag
            classValue="noOfWaAccountsUsed"
            label="WhatsApp Accounts (Used)"
            value={personalInfo.noOfWaAccountsUsed}
          />

          <InfoTag
            classValue="waMaxMessagesPerDay"
            label="WhatsApp Daily Message Limit"
            value={personalInfo.waMaxMessagesPerDay}
          />

          <InfoTag
            classValue="noOfAgentsEligible"
            label="Agents (Eligible)"
            value={personalInfo.noOfAgentsEligible}
          />

          <InfoTag
            classValue="noOfAgentsUsed"
            label="Agents (Used)"
            value={personalInfo.noOfAgentsUsed}
          />

          {liDailyUsage.map(
            ({
              id,
              name,
              email,
              unipileLookupCount,
              unipileLookupLimit,
              searchPerformedCount,
              maxSearchPerDay,
            }) => (
              <React.Fragment key={id}>
                <InfoTag
                  classValue="liDailyLookups"
                  label={`LinkedIn Lookups Today (${name || email})`}
                  value={`${unipileLookupCount} / ${unipileLookupLimit}`}
                />
                <InfoTag
                  classValue="liDailySearches"
                  label={`LinkedIn Searches Today (${name || email})`}
                  value={`${searchPerformedCount} / ${maxSearchPerDay}`}
                />
              </React.Fragment>
            ),
          )}
        </div>
      </div>
    </div>
  );
});

export default CreditsInfo;
